import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import Genres from './components/genres/genres';

import moment from 'moment';
import momenttz from 'moment-timezone';
import { DateTime } from 'luxon';
import Calendar from 'react-calendar';
import ScheduleAdd from './components/schedule/add';
import ScheduleEdit from './components/schedule/edit';
import Share from './components/share/share';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/schedule.css';
import { ButtonGroup } from 'react-bootstrap';

var newday = -1;
function ScheduleDate({schedule}) {
	const x = new Date(schedule.start*1000);
	if( x.getDay() !== newday ) {
		newday = x.getDay();
		return (
			<div className="col-12 mt-3">
				<div className="p-schedule-event-add">
					<div className="p-schedule-day p-2">
						{moment(schedule.start*1000).format("dddd Do MMMM")}
					</div>
				</div>
			</div>
		)
	} else return <></>;
}

export default class Schedule extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		let channel = '';
		switch(true) {
			case /hyper/i.test(window.location.pathname):
				channel = 'hyper';
				break;
			case /evolution/i.test(window.location.pathname):
				channel = 'evolution';
				break;
			default:
				channel = 'hyper';
				break;
		}
    this.state = {
			status: false,
			channel,
			date: new Date(),
			schedule: {},
			scheduleadd: false,
			scheduleedit: false,
			share: false,
			//schedulehover: 0,
		};
		this.setDate = this.setDate.bind(this);
    this.scheduleAdd = this.scheduleAdd.bind(this);
		this.scheduleEdit = this.scheduleEdit.bind(this);
		this.share = this.share.bind(this);
		//this.schedulehover = this.schedulehover.bind(this);
  };

  
	UNSAFE_componentWillReceiveProps(nextProps) {
		try {
			if( this.state.channel !== window.location.pathname.match(/\/(.*?)\//)[1] ) {
				this.setState({schedule: {}, channel: window.location.pathname.match(/\/(.*?)\//)[1] },()=>{
					this.componentDidMount();
				});
			}
		} catch(error) {
			this.setState({channel: 'hyper'},()=>{
				//this.componentDidMount();
			});
		}
	}

  
  async componentDidMount() {
		document.title = this.state.channel + " Schedule | Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.getSchedule();
	}

	componentWillUnmount() {
	}

	async getSchedule() {
		
		var d = new Date(this.state.date);
			d.setHours(0);
			d.setMinutes(0);
			d.setSeconds(0);

		var params = new URLSearchParams();
		params.append('channel', this.state.channel);
		params.append('schedule', Math.floor(d.getTime()/1000));
		const x = await postApi('/api/v2/schedule', params);
		this.setState({schedule: x.data, status: true});
	}

	setDate(e) {
		this.setState({date: e}, ()=>this.getSchedule());
	}

	scheduleAdd() {
		this.setState({scheduleadd: !this.state.scheduleadd});
	}

	scheduleEdit(e) {
		this.setState({scheduleedit: parseInt(e)+1});
	}

	share(e) {
		this.setState({share: e.toLowerCase()});
	}

	

	/*schedulehover(id) {
		const user = this.context;
		if( user.user.user.rank >= 5 ) {
			this.setState({schedulehover: id});
			return;
		}
		if( user.user.user.id === this.state.schedule[id].uid ) {
			this.setState({schedulehover: id});
		} else {
			this.setState({schedulehover: -1});
		}
	}*/

	close = (childData) => {
    this.setState({scheduleadd: false, scheduleedit: false, share: false}, () => {
			this.getSchedule();
		});
	}

	render() {
		const user = this.context;
		newday = 0;
		//let uk_time = user.user.user?.timezone;
		let _date = Math.floor(Date.now()/1000);
		
		let timezone_non = new Date().getTimezoneOffset()*-1;//.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
		let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;
		//console.log( timezone_non, timezone_uk );

		let width = 180;
		if( user?.user?.admin?.mod_access) width = 260;
		const schedule = 
      Object.keys(this.state.schedule).map((e,i) => {
        return (
					<React.Fragment key={i}>
						<ScheduleDate schedule={this.state.schedule[e]} />
						<div className="col-12" /*onMouseEnter={()=>this.schedulehover(e)} onMouseLeave={()=>this.schedulehover(0)}*/>
							<div className={`p-schedule-event ${this.state.schedule[e].cancelled===1&&this.state.schedule[e].dummy===0?'p-schedule-event-cancelled':''}`}>
								<Row className="gx-0">
									<Col xs={12} md={2} className="p-schedule-event-header text-vcenter">
										<div>
											{moment(this.state.schedule[e].start*1000).format("HH:mm - ")}
											{moment(this.state.schedule[e].end*1000).format("HH:mm")}

											{/*user.user.admin?.mod_access && timezone_non!==timezone_uk &&
												<>
													{/*&nbsp;{DateTime.local().toFormat('ZZZZ')}*}
													<br />
													<small>({moment((this.state.schedule[e].start+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} - {moment((this.state.schedule[e].end+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} UK)</small>
												</>
											*/}
										</div>
									</Col>
									<div className="p-schedule-event-image">
										<img src={`https://mix365.co.uk/${this.state.schedule[e].avatar}`} width="84" height="84" alt="profile avatar" />
									</div>
									<Col className="p-schedule-event-right text-vertical">
										<div>
											<Link to={this.state.schedule[e].username===null?'#':`/${this.state.schedule[e].username.replaceAll(' ','_')}`} className="pb-4">
												{this.state.schedule[e].djtitle?this.state.schedule[e].djtitle:this.state.schedule[e].title?this.state.schedule[e].title:this.state.schedule[e].username}
											</Link>{this.state.schedule[e].cancelled===1 && this.state.schedule[e].dummy===0 && <>&nbsp;&nbsp;Cancelled</>}<br />
											{this.state.schedule[e].description && <><span className="p-schedule-description">{this.state.schedule[e].description}</span><br /></>}
											{user.user?.admin?.admin_access && this.state.schedule[e]?.syndicate &&<><span className="p-schedule-syndicate">Syndicate: {this.state.schedule[e]?.syndicate}</span></>}
											<Genres genres={ this.state.schedule[e].genres.length > 0 ? this.state.schedule[e].genres : this.state.schedule[e].start>_date ? this.state.schedule[e].defaultgenres : [] } />
										</div>
									</Col>
									<Col xs={12} md={2} className="p-schedule-event-bottom text-vcenter">
										<div>
											{user.user.user.id===3&&<><small>schedule: {this.state.schedule[e].id}, uid: {this.state.schedule[e].uid}&nbsp;&nbsp;</small><br/></>}
											<ButtonGroup size="sm">
												{parseInt(this.state.schedule[e].pid) > 0 &&
													<Link to={`/${this.state.schedule[e].pid}/${this.state.schedule[e].showname}`}>
														<Button size="sm"><FontAwesomeIcon icon="play" />&nbsp;Replay</Button>
													</Link>
												}
												{parseInt(this.state.schedule[e].pid) > 0 ?
													<Button onClick={()=>this.share(`/${this.state.schedule[e].pid}/${this.state.schedule[e].showname}`)}><FontAwesomeIcon icon="cloud-arrow-up" />&nbsp;Share</Button>
												:
													<>
														{parseInt(this.state.schedule[e].sid) > 0 &&
															<Button onClick={()=>this.share(this.state.schedule[e].location)}><FontAwesomeIcon icon="cloud-arrow-up" />&nbsp;Share</Button>
														}
													</>
												}
												{((this.state.schedule[e].dummy===0 && user.user.user.id === this.state.schedule[e].uid) || (this.state.schedule[e].dummy===0 && user.user?.admin?.part_admin_access)) &&
													<Button onClick={()=>this.scheduleEdit(e)}><FontAwesomeIcon icon="bars" />&nbsp;Edit</Button>
												}
											</ButtonGroup>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</React.Fragment>
        )
      })
		return (
			<>
				{this.state.status &&
					<>
						<div className="schedule">
							<div className="schedule-background"></div>
						</div>
						<div className="website-background">

						</div>
						<div className="article" style={{paddingTop:200}}>
							<Row className="gx-0" style={{marginBottom: 100}}>
								<Col md={6} className="text-vcenter" style={{minHeight: 100}}>
									<div>
										<div className="home-header-white">Schedule</div>
										<div className="home-body" style={{fontSize: '2em'}}>Mix365 {this.state.channel}</div>
									</div>
								</Col>
								<Col md={6}>
									<Calendar onChange={this.setDate} value={this.state.date} maxDetail="month" next2Label='' prev2Label='' />
									<Row className="gx-0 py-1 px-3 schedule-select">
										<Col className="text-vcenter">
											Timezone: {DateTime.local().toFormat('ZZZZ')}
										</Col>
										<Col className="text-right">
											{user.user?.admin?.mod_access &&
												<>
													{/*(this.state.channel === 'clubbers' && !user.user.access.clubbers )  ?
														<Link to="/radio/schedule"><Button size="sm">Switch to Radio</Button></Link>
													:*/
														<Button size="sm" onClick={this.scheduleAdd}>Add Event</Button>
													}
												</>
											}
										</Col>
									</Row>
								</Col>
							</Row>
							
							<Row>
								<Col>
									<div className="row">
										{schedule}
									</div>
								</Col>
							</Row>
						</div>
					</>
				}
				{this.state.scheduleadd && <ScheduleAdd show={this.state.scheduleadd} close={this.close} channel={this.state.channel} /> }
				{this.state.scheduleedit!==false && <ScheduleEdit show={this.state.scheduleedit>0} close={this.close} schedule={this.state.schedule[this.state.scheduleedit-1]} channel={this.state.channel} /> }
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}
